import React, { Fragment } from 'react';
import ContactSection from './ContactSection';
import CreateContactForm from './CreateContactForm';
import ProjectContactService from '../../../services/ProjectContactService';
import StaticData from '../../../services/StaticData';

class ContactList extends React.Component {

  constructor(props) {
    super(props);

    this.handleCreate = this.handleCreate.bind(this);
    this.handleDelete = this.handleDelete.bind(this);

    this.state = {
      definitions: new Map(StaticData.ContactTypes.map(obj => [obj.id, obj.name])),
      projectId: 0,
      sections: []
    }
  }

  componentDidMount() {
    this.setState({ projectId: this.props.projectId }, this.loadData);
  }

  loadData() {

    if (this.state.projectId > 0) {
      return ProjectContactService
        .get({ projectId: this.props.projectId })
        .then(response => {
          return response.items.reduce((acc, curr) => {
            let contact = { id: curr.id, ...curr.attributes };
            let idx = acc.findIndex(x => x.id === contact.contactType);
            if (idx === -1) {
              acc.push({
                id: contact.contactType,
                name: this.state.definitions.get(contact.contactType),
                contacts: [{ ...contact }]
              });
            } else {
              acc[idx].contacts.push(contact);
            }

            return acc;
          }, []);
        })
        .then(sections => {
          return this.setState({ sections });
        });
    }
  }

  handleDelete(contact) {
    if (contact && contact.id) {
      return ProjectContactService
        .delete(contact.id)
        .then(() => this.loadData());
    }
  }

  handleCreate() {
    this.loadData();
  }

  render() {

    const { projectId, onDelete, onCreate, allowCreate, ...rest } = this.props;

    return (
      <Fragment>
        {this.state.sections && this.state.sections.map((section, index) => (
          <ContactSection
            {...rest}
            key={index}
            section={section}
            onDelete={this.handleDelete} />
        ))}
        {allowCreate &&
          <CreateContactForm
            projectId={this.state.projectId}
            onCreate={this.handleCreate} />}
      </Fragment>
    );
  }
}

export default ContactList;



// WEBPACK FOOTER //
// ./src/components/projects/ProjectContacts/ContactList.js